<template>
    <div
        class="px-4 sm:px-6"
        :class="faq.withSections ? 'space-y-10 py-4 sm:py-6' : 'divide-y'"
        :style="{
            'background-color': faq.backColor,
            'border-color': faq.borderColor,
            'border-radius': faq.borderRadius + 'px',
        }"
    >
        <ListSection
            v-for="section in sections"
            :key="section.id"
            :faq="faq"
            :section="section"
            :query="query"
            @adjustIframe="$emit('adjustIframe')"
        />
    </div>
</template>

<script>
import { useFaqGoTo } from "@/views/tools/faq/utils/useFaqGoTo";
import ListSection from "./ListSection.vue";

export default {
    name: "ListLayout",
    components: { ListSection },
    props: {
        faq: Object,
        sections: Array,
        query: String,
    },
    setup() {
        const { goToSectionField, goToQuestionField } = useFaqGoTo();
        return {
            goToSectionField,
            goToQuestionField,
        };
    },
    emits: ["adjustIframe"],
};
</script>
